// Please remember to track any user
// enrollment action in your parent VM,
// and to add the vm source_medium to your json
// Eg: Kadenze.Analytics.track('student_ui', 'enrollment_started', { source_medium: 'course_info', ... });

export default function(args) {
  let self = this;
  self.showSSORegister = ko.observable(Kadenze.isKadenze);
  self.showSSOLogin = ko.observable(false);
  self.showSignup = ko.observable(Kadenze.isKannu);
  self.showLogin = ko.observable(false);

  self.newuser = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    password: ko.observable(),
    password_confirmation: ko.observable(),
    agreed_to_terms_and_privacy: ko.observable()
  });

  self.loginuser = ko.observable({
    email: ko.observable(),
    password: ko.observable()
  });

  self.register = function(vm, evt) {
    let loader = Ladda.create(evt.target);
    loader.start();
    let req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_registration_path(),
      data: { user: ko.mapping.toJS(self.newuser) }
    });

    req.done(function(res) {
      self.just_registered = true;
      if (Kadenze.ENVIRONMENT === 'prod' && Kadenze.isKadenze) {
        Kadenze.WebApp.onFbLoaded(() => {
          fbq('init', '483925218455659', {
            em: res.resource.email.toLowerCase(),
            fn: res.resource.first_name.toLowerCase(),
            ln: res.resource.last_name.toLowerCase()
          });
          Kadenze.WebApp.fbEventTrack('CompleteRegistration', {
            content_name: 'login-modal'
          });
        });
        ga('send', { hitType: 'event', eventCategory: 'account',
          eventAction: 'CompleteRegistration', eventLabel: 'login-modal'
        });
      }
      Kadenze.Analytics.mpTrack('Register', _.extend({}, arg.trackingData, {auth_type: 'email'}));
      if (args.onRegister)
        args.onRegister(res);
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.login = function(vm, evt) {
    let loader = Ladda.create(evt.target);
    loader.start();
    let req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.user_session_path(),
      data: { user: ko.mapping.toJS(self.loginuser) }
    });

    req.done(function(res) {
      self.just_registered = true;
      Kadenze.Analytics.mpTrack('Login', _.extend({}, args.trackingData, {auth_type: 'email'}));
      if (res.csrf) {
        $('meta[name=\'csrf-token\']').prop('content', res.csrf);
      }
      if (args.onLogin)
        args.onLogin(res);
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.error;
      }
      new Kadenze.Notice.error({message: msg});
    });

    req.always(function() {
      loader.stop();
    });
  };

  self.initSSOEvents = function() {
    $('#email-register-btn').click(function() {
      self.showSSORegister(false);
      self.showSSOLogin(false);
      self.showSignup(true);
    });
    $('#email-login-btn').click(function() {
      self.showSSORegister(false);
      self.showSSOLogin(false);
      self.showLogin(true);
    });
    $('.js-oauth-btn').click(function() {
      let evtType = self.showSSOLogin() ? 'Login' : 'Register';
      Kadenze.Analytics.mpTrack(evtType, _.extend({}, args.trackingData, {auth_type: 'oauth', provider: $(this).data('oauth-type') }));
      $.cookie('register.oauth', true, { expires: 1 });
    });
  };

  const __construct = function(that) {
    console.log('constructor called for LoginModal');

  }(this);
}

